import { Component, ElementRef, Input } from '@angular/core';
import { BaseComponent } from 'app/com/ibm/tw/commons/mvc/base.component';
import { TxnService } from 'app/services';

@Component({
    standalone: false,
    selector: 'ccmotlgac-field-message',
    template: `
    <div class="txt_info txt_error" *ngIf="display">
        <i class="fa fa-warning" aria-hidden="true"></i>
        {{message}}
    </div>
    `,
})
export class CcmotlgacFieldMessageComponent extends BaseComponent {

    @Input() display: boolean = false;

    @Input() message: string = '';

    constructor(public el: ElementRef, public txnService: TxnService) {
        super(txnService);
    }

}
